// extracted by mini-css-extract-plugin
export default {"popupWindow":"modal_popupWindow__-CZKk"};